<template>
  <g>
    <path
      clip-rule="evenodd"
      d="M11.9883 2.63672C13.7602 3.63211 15.5259 4.63992 17.2852 5.66016C17.3125 7.80855 17.3164 9.957 17.2969 12.1055C16.6112 12.5128 15.9198 12.9112 15.2227 13.3008C15.2031 11.1993 15.1914 9.09771 15.1875 6.99609C13.4043 5.96578 11.6191 4.93845 9.83203 3.91406C10.5561 3.49357 11.2749 3.06778 11.9883 2.63672Z"
    />
    <path
      clip-rule="evenodd"
      d="M9.1289 4.32422C10.9208 5.32659 12.702 6.35004 14.4727 7.39453C14.5039 8.24609 14.5039 9.09766 14.4727 9.94922C12.7086 8.92859 10.9469 7.90514 9.18749 6.87891C7.36954 7.93048 5.55313 8.98516 3.73828 10.043C3.70703 9.18359 3.70703 8.32423 3.73828 7.46484C5.53663 6.41735 7.33349 5.37047 9.1289 4.32422Z"
    />
    <path
      clip-rule="evenodd"
      d="M18.082 6.08203C18.8098 6.48694 19.5324 6.90098 20.25 7.32422C20.2695 9.4024 20.2656 11.4805 20.2383 13.5586C18.3918 14.6745 16.5363 15.7761 14.6719 16.8633C13.9777 16.4699 13.2863 16.0715 12.5977 15.668C14.4141 14.5917 16.2344 13.5214 18.0586 12.457C18.082 10.3321 18.0898 8.20709 18.082 6.08203Z"
    />
    <path
      clip-rule="evenodd"
      d="M9.15234 7.62891C9.86965 8.02666 10.5806 8.43682 11.2852 8.85938C9.50775 9.90825 7.7265 10.9512 5.94141 11.9883C5.92577 14.0273 5.91016 16.0664 5.89453 18.1055C5.16883 17.6883 4.44619 17.2664 3.72656 16.8398C3.70704 14.832 3.71093 12.8242 3.73828 10.8164C5.54831 9.75919 7.353 8.6967 9.15234 7.62891Z"
    />
    <path
      clip-rule="evenodd"
      d="M8.49609 11.2617C8.53901 13.3006 8.55855 15.3475 8.55469 17.4023C10.3574 18.4463 12.1582 19.4931 13.957 20.543C13.3244 20.914 12.6916 21.2851 12.0586 21.6562C12.0352 21.6719 12.0117 21.6719 11.9883 21.6562C10.2188 20.6348 8.45318 19.6075 6.69141 18.5742C6.66405 16.4961 6.66016 14.418 6.67969 12.3398C7.29244 11.9887 7.89792 11.6293 8.49609 11.2617Z"
    />
    <path
      clip-rule="evenodd"
      d="M20.2383 14.3555C20.2656 15.1718 20.2695 15.9921 20.25 16.8164C18.3877 17.9331 16.5166 19.0347 14.6367 20.1211C12.8234 19.0953 11.0226 18.0484 9.23438 16.9805C9.21875 16.1758 9.21875 15.3711 9.23438 14.5664C11.0351 15.5996 12.832 16.6386 14.625 17.6836C16.5001 16.5774 18.3712 15.468 20.2383 14.3555Z"
    />
  </g>
</template>
